<template>
    <v-container grid-list-sm text-xs-left mt-4>
        <v-layout row wrap justify-left fill-height>
            <v-flex xs12>
                <!--<v-flex xs12>
                    <font size="7">
                        Try it out
                    </font>
                </v-flex>-->
                <StartupSearchList/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import StartupSearchList from "@/components/Lists/StartupSearchList";


    export default {
        name: "StartupSearch",
        components: {
            StartupSearchList
        },
        data() {
            return {
            };
        },
        methods: {

        },
    };
</script>

<style lang="scss" scoped>
    .v-window__container,
    .v-window-item  {
        height: 100%;
    }
</style>
